<template>
    <div>
        <el-select ref="selectRef" :loading="loading" v-model="newValue" placeholder="请选择" clearable filterable
            :multiple="multiple" @change="changeFun" @visible-change="handleVisibleChange" :collapse-tags="multiple"
            class="custom-multiple" @clear="handleClear" remote reserve-keyword :remote-method="remoteMethod"
            popper-class="my-select-dropdown">
            <!-- <template v-if="type == 'followlink'">
                <el-option v-for="item in clientData" :label="item.client_name" :value="item.client_id" :key="item.client_id"></el-option>
            </template> -->
            <!-- <template v-else> -->
                <el-option v-for="item in clientData" :label="item.name" :value="item.id" :key="item.id"></el-option>
            <!-- </template> -->
            <el-option :value="0" class="nodata" disabled  v-if="clientData.length == 0" >暂无数据</el-option>
        </el-select>
    </div>
</template>

<script>
import { custom_new_list , principalClient } from '@/api/custom'

export default {
    model: {
        prop: 'transvalue',
        event: 'change'
    },
    props: {
        transvalue: {
            type: [Array, String, Number],
            default: () => {
                return []
            },
        },
        multiple: {
            type: Boolean,
            default: true
        },
        pageSize: {
            type: Number,
            default: 25
        },
        type: {
            type: String,
            default: '' //followlink :跟进记录 关联 里的客户名称
        },
    },
    watch: {
        transvalue: {
            handler(newVal) {
                // console.log('props value 改变:', newVal);
                this.newValue = newVal;
            },
            immediate: true, // 组件挂载时立即执行
            deep: true // 深度监听
        },
    },
    data() {
        return {
            newValue: [],
            clientData: [],
            page_select: 1,
            query: '',
            loading_select: false,
            empty_end: false,
            scrollWrap: null,  // 保存滚动容器引用
            loading: false,
            controller: new AbortController(),
        }
    },
    methods: {
        changeFun() {
            this.$emit('change', this.newValue)
        },
        handleClear() {
            this.query = ''; // 保存查询关键字
            this.getdgys(true)
        },
        addData(obj){
            this.clientData.unshift(obj)
            this.clientData = Array.from(new Map(this.clientData.map(item => [item.id, item])).values());
        },
        handleVisibleChange(visible) {
            if (visible) {
                if (this.clientData.length == 0) {
                    this.query = '';
                    this.getdgys(true)
                }
                this.$nextTick(() => {
                    const popper = this.$refs.selectRef.$refs.popper;
                    if (popper) {
                        const scrollWrap = popper.$el.querySelector('.el-select-dropdown__wrap');
                        if (scrollWrap) {
                            this.scrollWrap = scrollWrap;
                            this.scrollWrap.addEventListener('scroll', this.handleScroll);
                            // console.log('已获取滚动容器');
                        }
                    }
                });
            } else {
                if (this.scrollWrap) {
                    this.scrollWrap.removeEventListener('scroll', this.handleScroll);
                    this.scrollWrap = null;
                    // console.log('已移除滚动监听');
                }
            }
        },
        remoteMethod(query) {
            if (query !== '') {
                this.query = query;
                this.getdgys(true)
            } else {
                this.clientData = [];
                this.query = '';
                this.getdgys(true)
            }
        },
        getdgys(isReset) {
            if (isReset) {
                this.page_select = 1
                this.clientData = [];
                this.empty_end = false;
                this.loading = true;
            }
            let data = {
                page: this.page_select,
                limit: this.pageSize,
                search_name: this.query,
            }
            this.loading_select = true
            this.controller.abort();
            this.controller = new AbortController()
            let httpurl = ''
            // if (this.type == 'followlink') {
            //     httpurl = principalClient(data, this.controller.signal)
            // } else {
                httpurl = custom_new_list(data, this.controller.signal)
            // }
            httpurl.then(res => {
                this.loading = false;
                this.loading_select = false;

                if (res.code === 200) {
                    // if (this.type == 'followlink') {
                    //     let data = this.clientData.concat(res.data.list)
                    //     //有重复的 直接去重
                    //     this.clientData = Array.from(new Map(data.map(item => [item.client_id, item])).values());
                    //     if (res.data.list.length == 0) {
                    //         this.empty_end = true
                    //     }
                    // } else {
                        let data = this.clientData.concat(res.data.table.list)
                        //有重复的 直接去重
                        this.clientData = Array.from(new Map(data.map(item => [item.id, item])).values());
                        if (res.data.table.list.length == 0) {
                            this.empty_end = true
                        }
                    // }
                } else {
                    this.page_select = Math.max(1, this.page_select - 1);
                }
            }).catch(error => {
                this.loading_select = false;
                this.loading = false;
                this.page_select = Math.max(1, this.page_select - 1);
            })
        },
        handleScroll(event) {
            const { scrollTop, scrollHeight, clientHeight } = event.target;
            if (scrollTop + clientHeight >= scrollHeight - 30) {
                if (!this.loading_select && !this.empty_end) {
                    this.page_select += 1;
                    this.getdgys();
                }
            }
        },
    },
    mounted() {
        this.newValue = this.transvalue;
        this.getdgys(true)
    },
    beforeDestroy() {
        // 组件销毁时清理事件监听
        if (this.scrollWrap) {
            this.scrollWrap.removeEventListener('scroll', this.handleScroll);
            this.scrollWrap = null;
        }
        this.controller.abort();
    }
}

</script>

<style scoped lang="scss">
.nodata {
    padding: 2px 0 !important;
    margin: 0 !important;
    text-align: center;
    color: #999 !important;
    font-size: 14px;
    height: auto !important;
    box-sizing: border-box;
    cursor: default !important;

    li {
        color: #999 !important;
        font-size: 14px !important;
    }
}
</style>